import * as yup from "yup";

import { BONUSCARD_DISCOUNT_PREFIX } from "@/utils/validation/config";
import * as RHFBonusCardValidationRules from "@/utils/validation/schemas/bonusCard.RHF";
import * as RHFPromoationValidationRules from "@/utils/validation/schemas/promotionCode.RHF";

export const PromotionInputFieldSchema = yup.object({
    codeInput: RHFPromoationValidationRules.promotionCode,
    bonusCard: yup
        .object({
            number: RHFBonusCardValidationRules.bonusCard
        })
        .optional()
        .default(undefined)
        .when("codeInput", {
            is: (codeInput?: string | null) =>
                (codeInput || "").startsWith(BONUSCARD_DISCOUNT_PREFIX),
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.optional()
        })
});

export type PromotionInputFormValues = yup.InferType<
    typeof PromotionInputFieldSchema
>;
